import { findBestMatchingByPenalty } from '@/services/utils/matching';

export function comparePairingCriteria(a, b) {
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return a[i] - b[i];
  }
  return 0;
}

// Критерии — неотрицательные целые числа. Каждый следующий приоритет
// не может перевесить предыдущий даже в сумме по всем парам.
export function matchByCriteria(players, evaluate, canPair = () => true) {
  const values = new Map();
  const maxima = [];
  const key = (a, b) => [a.id, b.id].sort().join('|');
  for (let i = 0; i < players.length; i++) {
    for (let j = i + 1; j < players.length; j++) {
      const a = players[i];
      const b = players[j];
      if (!canPair(a, b)) continue;
      const criteria = evaluate(a, b);
      values.set(key(a, b), criteria);
      criteria.forEach((value, index) => { maxima[index] = Math.max(maxima[index] || 0, value); });
    }
  }
  const pairCount = Math.floor(players.length / 2);
  const penalty = (a, b) => values.get(key(a, b)).reduce((score, value, index) =>
    score * (maxima[index] * pairCount + 1) + value, 0);
  return findBestMatchingByPenalty(players, penalty, canPair);
}
